import { ModalFuncProps } from 'antd/es/modal';
import { confirm } from 'components/atoms/modal';
import { useTranslation } from './use-translation';

export const useDeleteConfirmModal = (
  config: ModalFuncProps = {},
): (() => void) => {
  const okText = useTranslation('delete');
  const cancelText = useTranslation('cancel');

  return () =>
    confirm({
      okText,
      okType: 'danger',
      cancelText,
      onCancel: () => {},
      okButtonProps: {
        ...config.okButtonProps,
        className: `modal-confirm-button ${
          config.okButtonProps?.className ?? ''
        }`,
        style: {
          ...config.okButtonProps?.style,
          boxShadow:
            'var(--shadow-highlight) rgba(var(--red-60-in-rgb), var(--shadow-highlight-color-opacity))',
        },
      },
      ...config,
    });
};
